/**
 * Dashboard home translations: home (dashboard home page sections)
 */

export const home = {
  sectionAdmin: 'Administration',

  onboarding: {
    title: 'Starte mit deinem Free Namespace',
    subtitle: 'Dauerhaft kostenloser Kubernetes-Namespace',
    description:
      'Du hast noch keine aktiven Dienste. Fordere jetzt deinen kostenlosen Kubernetes-Namespace an und lege direkt los — oder stöbere in unseren Produkten.',
    browseProducts: 'Produkte entdecken'
  },

  quickActions: {
    title: 'Schnellaktionen',
    newTicket: 'Neues Ticket',
    newTicketDesc: 'Support anfragen',
    orderProduct: 'Produkt bestellen',
    orderProductDesc: 'Zum Shop',
    domains: 'Domains',
    domainsDesc: 'Domains verwalten',
    products: 'Produkte',
    productsDesc: 'Produkte verwalten'
  },

  alerts: {
    title: 'Benachrichtigungen',
    countOne: '{count} Hinweis',
    countMany: '{count} Hinweise',
    unread: '{count} ungelesen',
    noNew: 'Keine Hinweise',
    markAllRead: 'Alle als gelesen markieren',
    allGood: 'Alles im grünen Bereich',
    noNotifications: 'Keine Benachrichtigungen vorhanden',
    expiringSoonTitle: 'Läuft aus',
    expiringSoonMessage: '{name} läuft in {days} Tag(en) ab',
    expiringSoonAction: 'Anzeigen'
  },

  invoices: {
    title: 'Rechnungen',
    lastTransactions: 'Letzte {count} Rechnungen',
    viewAll: 'Alle anzeigen',
    status: {
      paid: 'Bezahlt',
      open: 'Offen',
      void: 'Storniert',
      uncollectible: 'Nicht bezahlt'
    }
  },

  packets: {
    title: 'Pakete',
    activePacket: '{count} aktives Paket',
    activePackets: '{count} aktive Pakete',
    manage: 'Verwalten',
    status: {
      active: 'Aktiv',
      canceled: 'Gekündigt',
      suspended: 'Ausgesetzt',
      inactive: 'Nicht aktiv'
    }
  },

  domainsCard: {
    title: 'Domains',
    registeredDomain: '{count} registrierte Domain',
    registeredDomains: '{count} registrierte Domains',
    manage: 'Verwalten',
    status: {
      active: 'Aktiv',
      canceled: 'Gekündigt',
      suspended: 'Ausgesetzt',
      inactive: 'Nicht aktiv'
    }
  },

  users: {
    title: 'Benutzerverwaltung',
    subtitle: 'Benutzerkonten und Berechtigungen',
    total: 'Gesamt',
    active: 'Aktiv',
    verified: 'Verifiziert',
    admins: 'Admins',
    resellers: 'Reseller',
    customers: 'Kunden',
    manage: 'Verwalten'
  },

  productsCard: {
    title: 'Produktverwaltung',
    subtitle: 'Produkt- und Preiskonfiguration',
    products: 'Produkte',
    systemProducts: 'System-Produkte',
    active: 'Aktiv',
    total: 'Gesamt',
    manage: 'Verwalten'
  },

  revenue: {
    title: 'Umsatzübersicht',
    subtitle: 'Monatliche Statistiken',
    comingSoon: 'Demnächst verfügbar',
    description: 'Hier werden Umsatzstatistiken und Trends angezeigt.'
  },

  systemHealth: {
    title: 'Systemstatus',
    subtitle: 'Server und Dienste',
    comingSoon: 'Demnächst verfügbar',
    description: 'Hier wird der Status aller Server und Dienste angezeigt.',
    apiServer: 'API Server',
    database: 'Datenbank',
    mailServer: 'Mail Server'
  },

  activity: {
    title: 'Aktivitätsprotokoll',
    subtitle: 'Letzte Aktionen',
    comingSoon: 'Demnächst verfügbar',
    description: 'Hier werden die letzten Aktivitäten im System angezeigt.'
  }
} as const
